import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { fetchRequestCreateAction } from 'state/actions/request-create';
import { RequestCreateForm } from '../index';

interface ExternalProps {
    portalId: number;
    requestTypeId: number;
}

interface CsmRequestCreateFormProps extends ExternalProps {
    fetchRequestCreate: typeof fetchRequestCreateAction;
}

const CsmRequestCreateForm: React.FC<CsmRequestCreateFormProps> = ({ fetchRequestCreate, ...props }) => {
    const { portalId, requestTypeId } = props;

    useEffect(() => {
        fetchRequestCreate({ portalId, id: requestTypeId }, {});
    }, [fetchRequestCreate, portalId, requestTypeId]);

    return <RequestCreateForm {...props} />;
};

export default connect(null, {
    fetchRequestCreate: fetchRequestCreateAction,
})(CsmRequestCreateForm);
